/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {Loader} from './loader';

export const Button = ({
  buttonProps, label, loading, loaderClassName,
}) => (
  <button {...buttonProps}>
    {loading
      ? (
        <Loader className={`loader ${loaderClassName}`} />
      )
      : label }

  </button>
);
Button.propTypes = {
  buttonProps: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.instanceOf(Object).isRequired,
  loading: PropTypes.bool.isRequired,
  loaderClassName: PropTypes.string.isRequired,
};
